export const androidStoreURL =
  'https://play.google.com/store/apps/details?id=com.struxhub.mobile'

export const iosStoreURL = 'https://apps.apple.com/us/app/struxhub/id6747824082'
